import {Box} from '@mui/material';
import PropTypes from 'prop-types';

const PageWrapper = ({children, maxWidth, ...sxProps}) => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      overflowY: 'scroll',
      paddingBlock: 4,
      paddingInline: 5,
      ...sxProps,
    }}
  >
    <Box
      sx={{
        maxWidth: maxWidth ?? 'lg',
        margin: '0px auto',
      }}
    >
      {children}
    </Box>
  </Box>
);

PageWrapper.propTypes = {
  children: PropTypes.any,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
export default PageWrapper;
